export default "__VITE_ASSET__wnGpVp_l__"